import { defineMessages } from 'react-intl'

export default defineMessages({
  rejectedError: {
    id: 'FormError.RejectedFile',
    defaultMessage: 'File "{name}" is invalid.'
  }
})
